import { Rng } from './rng';

/**
 * Weapon mods (GDD: Combat): found in caches during a run, lost with it. Each takes one of the
 * suit's mod slots, which Arsenal upgrades add.
 * - `spread`: every laser is three, in a fan.
 * - `pierce`: lasers go through enemies, hitting each once.
 * - `homing`: rockets steer toward the nearest enemy in their lane.
 */
export const MOD_IDS = ['spread', 'pierce', 'homing'] as const;
export type ModId = (typeof MOD_IDS)[number];

/**
 * The mod in a cache: one the suit doesn't hold yet, picked by the room and the cache's place (so
 * a replayed seed, opening it with the same mods held, finds the same), or null when it holds
 * them all.
 */
export function cacheMod(cacheKey: string, held: readonly ModId[]): ModId | null {
  const left = MOD_IDS.filter((m) => !held.includes(m));
  if (left.length === 0) return null;
  return left[Rng.fromSeed(cacheKey).nextInt(left.length)] ?? null;
}
